/**
 * Reads a custom css theme variable and populates value to a data-attribute supported by Bootstrap
 */
export function addBsThemeScssSupport (elem: Element, cssVariable:string = "--duke-bs-theme") {
  const theme = getComputedStyle(window.document.documentElement).getPropertyValue(cssVariable);
  if (theme && elem)  {
    elem.setAttribute('data-bs-theme', theme);
  }
}
